module.exports = __webpack_public_path__ + "static/media/chat-start.db985e90.svg";